<script setup>
import store from '@/store';
import { CRY_TYPE, SMILE_TYPE, WELL_DYING_CODE } from '@/common/constants/ConstCode';
import { ref } from 'vue';
import router from '@/router';

const emits = defineEmits(['close']);
const { data } = defineProps(['data']);
const { key } = data;

const selectedKey = ref('');

store.commit('layout/setIsNav', false);

const contents = {
  SMILE: {
    title: '관리하실 Smile Together 메뉴를 선택해주세요.',
    items: [
      { key: SMILE_TYPE.WEDDING.key, label: '온라인 결혼식 관리' },
      { key: SMILE_TYPE.HUNDRED.key, label: '백일잔치/돌잔치 관리' },
      { key: SMILE_TYPE.OLDER.key, label: '육순/칠순/팔순/구순/백세 관리' },
      { key: SMILE_TYPE.HAPPY_BIRTH.key, label: '생일축하 관리' },
      { key: SMILE_TYPE.OPEN_STORE.key, label: '개업식 관리' },
      { key: SMILE_TYPE.CHRIST.key, label: '세례식 관리' },
      { key: 'INVITATION', label: '온라인 초대장 관리' }
    ]
  },

  CRY: {
    title: '관리하실 Cry Together 메뉴를 선택해주세요.',
    items: [
      { key: CRY_TYPE.MEMORIAL_IN.key, label: '인사이드 추모관 관리', path: '/more/memorial' },
      { key: CRY_TYPE.MEMORIAL_OUT.key, label: '아웃사이드 추모관 관리', path: '/more/memorial' },
      { key: CRY_TYPE.ANDERSEN.key, label: '안데르센관 관리', path: '/more/memorial' },
      { key: CRY_TYPE.ANNOUNCEMENT.key, label: '온라인 부고장 관리', path: '/more/announcement' },
      { key: CRY_TYPE.FUNERAL.key, label: '온라인 장례식장 관리', path: '/more/funeral' }
    ]
  },

  LIKE: {
    title: '좋아요된 게시글을 보실 메뉴를 선택헤주세요.',
    items: [
      { key: 'STORE', label: 'Business Together', infoText: '내가 좋아요한 업체 보기' },
    ]
  },

  CARD: {
    title: '명함 메뉴를 선택해주세요.',
    items: [
      { key: 'MY_CARD', label: '내 명함', path: '/card/my' },
      { key: 'RECEIVED_CARD', label: '받은 명함함', path: '/card/received' }
    ]
  }
};

/*
 selectKey : WELL_PRAY || STORE
 */
function pushToLike(selectedKey) {
  if (selectedKey === WELL_DYING_CODE.WELL_PRAY.key) {
    router.push('/more/like/pray');
  } else {
    router.push('/more/like/business');
  }
}

const fnPush = () => {
  if (selectedKey.value === 'INVITATION') {
    pushToInvitation();
    return;
  }

  switch (key) {
    case 'SMILE':
      pushToSmile(key, selectedKey.value);
      break;
    case 'LIKE':
      pushToLike(selectedKey.value);
      break;
    case 'CRY':
      pushToCry(key, selectedKey.value);
      break;
    case 'CARD':
      router.push(contents[key].items.find(item => item.key === selectedKey.value).path);
      closeModal();
      break;
  }

  closeModal();
};

const pushToSmile = (key, category) => {
  router.push({
    path: '/smile/event/list',
    query: {
      key: key,
      header: contents[key].items.find(item => item.key === category).label,
      category: category
    }
  });
  closeModal();
};

const pushToCry = (key, category) => {
  router.push({
    path: contents[key].items.find(item => item.key === category).path,
    query: {
      memorialType: category
    }
  });
};

const pushToInvitation = () => {
  router.push('/smile/invitation/list');
  closeModal();
};

const closeModal = () => {
  store.commit('layout/setIsNav', true);
  emits('close');
};
</script>

<template>
  <div class="modal-dim on">
    <!--'on 추가'-->
    <div class="modal-wrap">
      <div class="modal-inner bottom">
        <div class="modal">
          <div class="modal-con" style="max-height: none !important;">
            <p class="modal-notice">{{ contents[key].title }}</p>
            <ul class="ticket-list pd0">
              <!--pd0-->
              <!--onclick="classList.toggle('on')"-->
              <li
                class="card ticket"
                :class="selectedKey === item.key ? 'on' : ''"
                v-for="item in contents[key].items"
                @click="selectedKey = item.key"
              >
                <div class="title-wrap">
                  <h3 class="title">{{ item.label }}</h3>
                </div>
                <p class="info-txt" v-if="key === 'LIKE'">{{ item.infoText }}</p>
              </li>
            </ul>
          </div>
          <div class="modal-btn">
            <div class="btn-wrap">
              <button class="btn medium border-gray" @click="closeModal">닫기</button>
              <button class="btn primary medium" @click="fnPush">선택</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
